import { x } from '@xstyled/styled-components';
import React, { useState } from 'react';
import { t } from 'ttag';
import { usePostCommentMutation } from '~/data';
import { Button } from '~/ui/buttons';
import { PickList } from '~/ui/pick-list/PickList';
import { Spinner } from '~/ui/spinner/Spinner';
import { Sequence, useTrainingStore } from '../../state';
import { useTrainingParams } from '../../useTrainingParams';
import { getUA } from 'react-device-detect';

interface Props {
  topics?: {
    key: string;
    label: string;
  }[];
  recipient: 'easyllama' | 'company';
}

export const IssueForm = ({ topics, recipient }: Props) => {
  const [question, setQuestion] = useState('');
  const { learnerTrainingId, sequenceId } = useTrainingParams();
  const items = useTrainingStore(s => s.items);
  const [topic, setTopic] = useState(topics && topics[0]);
  const [postComment, { called, loading, data, error }] =
    usePostCommentMutation();

  const handleClick = () => {
    const sequence = items.find(
      i => i.kind === 'sequence' && i.id === sequenceId
    ) as Sequence;

    postComment({
      variables: {
        learnerTrainingUuid: learnerTrainingId!,
        question,
        recipient,
        chapterSequenceId: sequence.chapterSequenceId,
        topic: topic?.key,
        userAgent: getUA
      }
    });
  };

  if (loading) return <Spinner />;

  if (error || data?.comment?.errors.length)
    return <div>{t`We're sorry, an unexpected error has occurred`}</div>;

  if (!called) {
    return (
      <x.div minWidth="332px">
        {topics && (
          <x.div>
            <PickList
              items={topics}
              selected={topic}
              labelField="label"
              valueField="key"
              onSelect={t => setTopic(t)}
            />
          </x.div>
        )}
        <x.label htmlFor="writeYourMessage">{t`Write your message`}. <x.span color='red'>* {t`required`}</x.span></x.label>
        <x.textarea
          id="writeYourMessage"
          h="130px"
          w="95%"
          p="sm"
          resize="none"
          mt="20px"
          onChange={e => setQuestion(e.target.value)}
          className="textareaStyleForDarTheme"
          required
        />
        <Button
          disabled={!question.length}
          onClick={handleClick}
        >{t`Send`}</Button>
      </x.div>
    );
  }

  return (
    <div aria-live="assertive">{t`Your message was sent successfully.`}</div>
  );
};
